import ReactPDF, { View, Page, Text, StyleSheet, Font, Image, Link } from "@react-pdf/renderer";
import { styles } from "./pdfstyles";
import { BalanceData } from "../components/BalanceCalc";
import { riskLevel } from "../components/AnalyseCalc";
import { DangerRow } from "./DangerRow";

export default function BalancePDF(pdf: BalanceData) {

    Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
    })

    const questionText = (checked: boolean, value?: string) => {

        return checked
            ? <Text>TAK, {value}</Text>
            : <Text>NIE</Text>
    }

    return (
        <ReactPDF.Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.title}>
                    <Image src="https://e-rodo.eu/images/ready/test_rownowagi.jpg" style={{height: "171px"}} />
                </View>
                <View style={styles.title}>
                    <Text>Formularz testu równowagi</Text>
                </View>
                <View style={styles.normalText}>
                    <Text>Aby ułatwić ocenę, przedstawiamy narzędzie, które pozwoli dokonać oceny, krok po kroku. Jest to narzędzie pomocne dla osób odpowiedzialnych za zgłoszenie, które nie muszą mieć wystarczającego doświadczenia w dziedzinie ochrony danych osobowych, a chcą wywiązać się z obowiązków wynikających z przepisów RODO.</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>1) Test celu</Text>
                    <Text style={styles.header}>Jaki jest cel przetwarzania?</Text>
                    <Text>{pdf.processingPurpose}</Text>
                    <Text style={styles.header}>Jaki korzyści Administrator zamierza osiągnąć z przetwarzania danych osobowych?</Text>
                    <Text>{pdf.addValue}</Text>
                    <Text style={styles.header}>Czy interes ten jest rzeczywisty i aktualny?</Text>
                    <Text>{questionText(pdf.isBusinessReal, pdf.businessReal)}</Text>
                    <Text style={styles.header}>Czy są inne podstawy przetwarzania, na których można oprzeć przetwarzanie?</Text>
                    <Text>{questionText(pdf.isAnyOtherJustification, pdf.otherJustification)}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>2) Test niezbędności</Text>
                    <Text style={styles.header}>Czy przetwarzanie jest konieczne w celu realizacji uzasadnionego interesu?</Text>
                    <Text>{questionText(pdf.isProcessingNecessary, pdf.processingNecessary)}</Text>
                    <Text style={styles.header}>Czy wszystkie dane są niezbędne dla wskazanego celu?</Text>
                    <Text>{questionText(pdf.isAllDataNecessary, pdf.allDataNecessary)}</Text>
                    <Text style={styles.header}>Czy okres przechowywania nie wykracza poza to, co niezbędne?</Text>
                    <Text>{questionText(pdf.isSaveTimeExceed, pdf.saveTimeExceed)}</Text>
                    <Text style={styles.header}>Czy można osiągnąć dany cel bez przetwarzania danych lub innymi środkami, które mniej ingerują w prywatność osoby, której dane dotyczą?</Text>
                    <Text>{questionText(pdf.isGoalAchievedWithout, pdf.goalAchievedWithout)}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>3) Test równowagi</Text>
                    <Text style={styles.header}>Jakie rodzaje danych osobowych będą przetwarzane w danym procesie?</Text>
                    <Text>{pdf.personalDataKind}</Text>
                    <Text style={styles.header}>Jakie kategorie osób będą przetwarzane  w danym procesie? Czy są wśród nich dzieci lub inne osoby wymagające szczególnej opieki?</Text>
                    <Text>{pdf.personalDataCategory}</Text>
                    <Text style={styles.header}>Skąd pochodzą dane osobowe?</Text>
                    <Text>{pdf.dataOrigin}</Text>
                    <Text style={styles.header}>Czy osoba, której dane dotyczą, ma rozsądne oczekiwania wobec przetwarzania?</Text>
                    <Text>{pdf.personalExpectations}</Text>
                    <Text style={styles.header}>Jaki charakter ma przetwarzanie danych osobowych?</Text>
                    <Text>{pdf.processingCharacter}</Text>
                    <Text style={styles.header}>Czy może mieć pozytywny wpływ na osobę?</Text>
                    <Text>{questionText(pdf.isPositiveImpact, pdf.positiveImpact)}</Text>
                    <Text style={styles.header}>Czy może mieć negatywny wpływ na osobę? Jakie są zagrożenia dla interesów lub praw i wolności osoby?</Text>
                    <Text>{questionText(pdf.isNegativeImpact, pdf.negativeImpact)}</Text>
                    <Text style={styles.header}>Czy osoba, której dane dotyczą, ma kontrolę nad swoimi danymi?</Text>
                    <Text>{questionText(pdf.isPersonalControl, pdf.personalControl)}</Text>
                    <Text style={styles.header}>Czy osoba, której dane dotyczą, jest przejrzyście informowana o prawnie uzasadnionym interesie Administratora?</Text>
                    <Text>{questionText(pdf.isPersonInformed, pdf.personInformed)}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>4) Analiza ryzyka</Text>
                    <DangerRow name="Naruszenie" values={pdf.risks.map(x => x.name)} />
                    <DangerRow name="Prawdopodobieństwo" values={pdf.risks.map(x => x.probability)} />
                    <DangerRow name="Skutki" values={pdf.risks.map(x => x.effect)} />
                    <DangerRow name="Ryzyko" values={pdf.risks.map(x => riskLevel(x).text)} />
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>5) Wynik testu</Text>
                    <Text style={styles.header}>Czy interes administratora przeważa?</Text>
                    <Text>{questionText(pdf.isAdminBusiness, pdf.adminBusiness)}</Text>
                    <Text style={styles.header}>Decyzja administratora danych</Text>
                    <Text>{pdf.adminDecision}</Text>
                </View>
                <View style={styles.mt2}>
                    <Text style={styles.textTitle}>ZASTRZEŻENIE</Text>
                    <Text style={styles.text}>Wyniki podane przez kalkulator są orientacyjne i pomocnicze, nie mogą być jedyną podstawą do podejmowania działań ani do pełnej diagnozy stanu faktycznego. Nie ponosimy jakiejkolwiek odpowiedzialności za skutki uboczne korzystania z kalkulatora. Dodatkowe szczegóły w zakresie przepisów prawa: art. 24 i art. 32 RODO. Potrzebujesz pomocy? Skontaktuj się z nami i umów się na spotkanie.</Text>
                </View>
                <View>
                    <Text style={styles.textTitle}>WSPARCIE</Text>
                    <Text style={styles.text}>Wspieramy w zakresie ochrony danych i obsługi naruszeń ochrony danych oraz w ich klasyfikacji.</Text>
                </View>
                <View style={styles.center}>
                    <Link src="https://e-rodo.eu/kontakt.php#contact-section">
                        <Image src="https://e-rodo.eu/images/ready/PDF.jpg" style={{height: "171px"}} />
                    </Link>
                </View>
            </Page>
        </ReactPDF.Document>
    )
}

